<template>
  <div class="card">
    <div class="card-header bg-light">
      <h5 class="my-0">Product Details</h5>
    </div>
    <div class="card-body d-flex align-items-center">
      <div class="w-100">
        <b-table
          :fields="tableColumns"
          :items="cartArr"
          head-variant="light"
          class="table-nowrap"
          hover
          responsive
          no-local-sorting
        >
          <template #cell(product_title)="data">
            <div class="d-flex align-items-center">
              <fmv-avatar :title="true" title-class="bg-transparent" no-link slot="aside">
                <b-img
                  :src="data.item.product_url"
                  class="img-fluid"
                  width="40"
                  alt="Logo"
                  v-if="data.item.product_url"
                />
                <i class="fas fa-bag-shopping" v-else></i>
              </fmv-avatar>
              {{ data.item.product_title }}
            </div></template
          >

          <template #cell(price)="data"> {{ $n(data.item.price, 'currency', 'en-US') }}</template>
          <template #cell(quantity)="data">{{ $n(data.item.quantity) }}</template>
          <template #cell(color)="data">
            <span v-if="data.item.color" class="d-inline-flex align-items-center text-nowrap">
              <span
                class="product-color-swatch mr-2"
                :style="{ backgroundColor: data.item.color }"
                :title="data.item.color"
              ></span>
              {{ getProductColorName(data.item, data.item.color) }}
            </span>
            <span v-else class="text-muted">&mdash;</span>
          </template>

          <template #cell(amount)="data"> {{ $n(data.item.quantity * data.item.price, 'currency', 'en-US') }}</template>

          <template v-slot:custom-foot>
            <tr>
              <th>Total</th>
              <th />
              <th />
              <th />
              <th />
              <th>{{ $n(total, 'currency', 'en-US') }}</th>
            </tr>
          </template>
        </b-table>
      </div>
    </div>
  </div>
</template>

<script>
import { FmvAvatar } from 'fmv-avatar';
import { getProductColorName } from '@/common/colorNames';
export default {
  name: 'ProductCheckoutCard',
  props: {
    cartArr: { type: Array, default: () => [] },
  },
  components: {
    FmvAvatar,
  },
  methods: {
    getProductColorName,
  },
  computed: {
    tableColumns() {
      return [
        { key: 'product_title', label: 'Product' },
        { key: 'price', label: 'Price' },
        { key: 'quantity', label: 'Quantity' },
        { key: 'size', label: 'Size' },
        { key: 'color', label: 'Color' },
        { key: 'amount', label: 'Amount' },
      ];
    },

    total() {
      return this.cartArr.reduce((total, item) => item.price * item.quantity + total, 0);
    },
  },
  async mounted() {},
};
</script>

<style scoped>
.product-color-swatch {
  display: inline-block;
  width: 18px;
  height: 18px;
  border: 1px solid #c7ccd1;
  border-radius: 50%;
}
</style>
